import React from 'react';
import { ActionButton } from '../buttons/ActionButton';
import { Mode } from '../../types';
import { HostType } from '../../types/office';

interface ActionButtonsProps {
  mode: Mode;
  hasOriginalEmail: boolean;
  isStreaming: boolean;
  host: HostType;
  onSummarize: () => void;
  onReplyOptions: () => void;
  onActionItems: () => void;
  onGrammar: () => void;
  onReview: () => void;
  onProfessional: () => void;
  onNotes?: () => void;
  onRewrite?: () => void;
  onPivotTable?: () => void;
  isDisabled?: boolean; // <-- add this
}

export const ActionButtons: React.FC<ActionButtonsProps> = ({
  mode,
  hasOriginalEmail,
  isStreaming,
  host,
  onSummarize,
  onReplyOptions,
  onActionItems,
  onGrammar,
  onReview,
  onProfessional,
  onNotes,
  onRewrite,
  onPivotTable,
  isDisabled = false // <-- add this
}) => {
  // Excel-specific buttons
  if (host === "Excel") {
    return (
      <div className="actionsBox">
        <ActionButton 
          text="Summarize selection" 
          onClick={onSummarize} 
          disabled={isStreaming || isDisabled}
        />
        <ActionButton 
          text="Recommend a pivot table" 
          onClick={onPivotTable || (() => {})} 
          disabled={isStreaming || isDisabled}
        />
      </div>
    );
  }

  // PowerPoint-specific buttons
  if (host === "PowerPoint") {
    return (
      <div className="actionsBox">
        <ActionButton 
          text="Summarize presentation" 
          onClick={onSummarize} 
          disabled={isStreaming || isDisabled}
        />
        <ActionButton 
          text="Generate notes" 
          onClick={onNotes || (() => {})} 
          disabled={isStreaming || isDisabled}
        />
        <ActionButton 
          text="Rewrite content" 
          onClick={onRewrite || (() => {})} 
          disabled={isStreaming || isDisabled}
        />
      </div>
    );
  }

  // Word-specific buttons (always shown for Word)
  if (host === "Word") {
    return (
      <div className="actionsBox">
        <ActionButton 
          text="Summarize document" 
          onClick={onSummarize} 
          disabled={isStreaming || isDisabled}
        />
        <ActionButton 
          text="Check grammar" 
          onClick={onGrammar} 
          disabled={isStreaming || isDisabled}
        />
      </div>
    );
  }

  // Outlook-specific buttons
  if (mode === "read") {
    return (
      <div className="actionsBox">
        <ActionButton 
          text="Summarize this email" 
          onClick={onSummarize} 
          disabled={isStreaming || isDisabled} // <-- update
        />
        <ActionButton 
          text="Suggest a reply" 
          onClick={onReplyOptions} 
          disabled={isStreaming || isDisabled} // <-- update
        />
        <ActionButton 
          text="List action items" 
          onClick={onActionItems} 
          disabled={isStreaming || isDisabled} // <-- update
        />
      </div>
    );
  }
  
  if (mode === "compose") {
    return (
      <div className="actionsBox">
        <ActionButton 
          text="Check grammar" 
          onClick={onGrammar} 
          disabled={isStreaming || isDisabled} // <-- update
        />
        {hasOriginalEmail ? (
          <ActionButton 
            text="Suggest a reply" 
            onClick={onReplyOptions} 
            disabled={isStreaming || isDisabled} // <-- update
          />
        ) : (
          <ActionButton 
            text="Generate a template" 
            onClick={onReview} 
            disabled={isStreaming || isDisabled} // <-- update
          />
        )}
        <ActionButton 
          text="Polish Email Draft" 
          onClick={onProfessional} 
          disabled={isStreaming || isDisabled} // <-- update
        />
      </div>
    );
  }
  
  return null;
};